/* Recurring promotional countdown: no fixed sale deadline. */
(function () {
  'use strict';

  function initialize(root) {
    if (!root || root.__velorSaleDispose) return;
    const fields = {
      hours: root.querySelector('[data-sale-unit="hours"]'),
      minutes: root.querySelector('[data-sale-unit="minutes"]'),
      seconds: root.querySelector('[data-sale-unit="seconds"]')
    };
    const timer = root.querySelector('[data-sale-timer]');
    if (!fields.hours || !fields.minutes || !fields.seconds || !timer) return;

    const durationSeconds = Math.max(60, Math.floor(Number(root.dataset.cycleSeconds)) || 43200);
    const durationMs = durationSeconds * 1000;
    const storageKey = 'velor:countdown:' + root.id + ':' + durationSeconds;
    let nextReset = Date.now() + durationMs;
    let stored = false;

    try {
      const saved = Number(window.localStorage.getItem(storageKey));
      if (Number.isFinite(saved) && saved > 0) {
        nextReset = saved;
        stored = true;
      }
    } catch (e) { /* Timers still work when browser storage is unavailable. */ }

    function save() {
      try { window.localStorage.setItem(storageKey, String(nextReset)); } catch (e) { /* no-op */ }
    }
    if (!stored) save();

    function update() {
      if (!root.isConnected) { dispose(); return; }
      const now = Date.now();
      if (now >= nextReset) {
        const completedCycles = Math.floor((now - nextReset) / durationMs) + 1;
        nextReset += completedCycles * durationMs;
        save();
      }
      const remainingSeconds = Math.max(0, Math.ceil((nextReset - now) / 1000));
      const hours = Math.floor(remainingSeconds / 3600);
      const minutes = Math.floor((remainingSeconds % 3600) / 60);
      const seconds = remainingSeconds % 60;
      fields.hours.textContent = String(hours).padStart(2, '0');
      fields.minutes.textContent = String(minutes).padStart(2, '0');
      fields.seconds.textContent = String(seconds).padStart(2, '0');
      timer.setAttribute('aria-label', 'Recurring promotion timer: ' + hours + ' hours and ' + minutes + ' minutes');
    }

    const intervalId = window.setInterval(update, 1000);
    function dispose() {
      window.clearInterval(intervalId);
      root.__velorSaleDispose = null;
    }
    root.__velorSaleDispose = dispose;
    update();
  }

  function eachTimer(node, callback) {
    if (node.matches && node.matches('[data-velor-sale-countdown]')) callback(node);
    if (node.querySelectorAll) node.querySelectorAll('[data-velor-sale-countdown]').forEach(callback);
  }

  function initAll() { eachTimer(document, initialize); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:unload', function (event) {
    eachTimer(event.target, function (node) {
      if (node.__velorSaleDispose) node.__velorSaleDispose();
    });
  });
  document.addEventListener('shopify:section:load', function (event) {
    eachTimer(event.target, initialize);
  });
})();
